import React from 'react';
import { connect } from 'react-redux';
import { autocompleteActiveQuerySelector } from 'app/reducers/autocomplete';
import AutoCompleteSearch from './AutoCompleteSearch';
import { updateActiveQuery } from '../../../actions/header/autocomplete';
import { networkOnlineSelector } from '../../../reducers/network';
import { getContentoAbTestVariants } from '../../../utils/abiskoUtils';

// eslint-disable-next-line react/jsx-props-no-spreading
const AutoCompleteSearchFormContainer = (props) => <AutoCompleteSearch {...props} />;

const mapDispatchToProps = (dispatch) => ({
    updateActiveQuery: (query) => {
        dispatch(updateActiveQuery({ query }));
    },
});

const mapStateToProps = (state, ownProps) => ({
    ...ownProps,
    activeResult: autocompleteActiveQuerySelector(state),
    networkOnline: networkOnlineSelector(state),
    contentoAbTestVariants: getContentoAbTestVariants(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoCompleteSearchFormContainer);
